import React from 'react'
import ListPage from 'components/cases/listpage/ListPage'

interface pageProps {
  pageId: number
}
export const categoryTitle = '特徴量エンジニアリングと生成AI'
export const baseUrl = '/cases/feature-engineering/'

const Template: React.FC<pageProps> = ({ pageId }) => {
  return <ListPage categoryTitle={categoryTitle} baseUrl={baseUrl} pageId={pageId} />
}

export default Template
